import { Component, OnInit } from '@angular/core';
import { TranslateModule, TranslateService} from '@ngx-translate/core';
import { LoaderService, ReservationService, StorageService } from 'core-lib';

@Component({
    selector: 'app-payment-success',
    imports: [TranslateModule],
    templateUrl: './payment-success.component.html',
    styleUrl: './payment-success.component.scss'
})
export class PaymentSuccessComponent implements OnInit{
  
  showSimulationText:boolean = false;
  
  constructor(private reservationService: ReservationService, private storage: StorageService) {}

  ngOnInit(): void {

    let disablePaymentSuccess = this.storage.loadSessionStorage('disablePaymentSuccess');
    if (disablePaymentSuccess) {
      this.showSimulationText = true
    }
    else {
      this.reservationService.redirectToConfirmationAfterSuccesfulPayment(window.location.search);
    }

  }

  
}
